import React, {useState} from 'react';
import PropTypes from 'prop-types';
import 'components/styles/dialog.css';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { PARTNERSHIP_URL } from '../constants/index';
import { ReactComponent as CloseIcon } from 'assets/images/black-close.svg';
import { ReactComponent as HintIcon } from 'assets/images/hint-icon.svg';

const DeleteDialog = ({ onClose, setShowDeleteSuccessMessage, employeeData }) => {
  const [deleteError, setDeleteError] = useState('');
  const cookies = new Cookies();

  const handleDelete = async () => {
    const token = cookies.get('token');

    try {
      const response = await axios.delete(
        `${PARTNERSHIP_URL}/employees/${employeeData.employeeCode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.status === 200) {
        setShowDeleteSuccessMessage(true);
        onClose();
      }
    } catch (error) {
      setDeleteError(error.response.data.message);
      throw new Error(error);
    }
  };
  return (
    <div className="dialog-container">
      <div className="dialog-content">
        <div className="dialog-header">
          <div className="dialog-head">Delete account</div>
          <div className="close-button" onClick={onClose}>
            <CloseIcon/>
          </div>
        </div>
        <div className="dialog-body">
          <div className="dialog-text">Permanently delete the record, you can’t undo this.</div>
          <div className="dialog-actions">
            <div className="dialog-cancel" onClick={onClose}>
              Cancel
            </div>
            <div className="dialog-delete" onClick={handleDelete}>
              Delete
            </div>
          </div>
          {deleteError ? (
            <div className="delinkError">
              <HintIcon/>
              {deleteError}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

DeleteDialog.propTypes = {
  onClose: PropTypes.func,
  setShowDeleteSuccessMessage: PropTypes.func,
  employeeData: PropTypes.object
};

export default DeleteDialog;
